import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import { project } from "@arcgis/core/geometry/projection";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";

import {
  buffer as geometryEngineBuffer,
  union as geometryEngineUnion,
} from "@arcgis/core/geometry/geometryEngine";
import Graphic from "@arcgis/core/Graphic";
import { useDispatch, useSelector } from "react-redux";
import { bufferFeatureData } from '../../store/slice/bufferSlice'
import { ToastContainer, toast } from 'react-toastify';
import { setBufferData } from "../../store/slice/bufferSlice";
import { reSetMap, setIsSidebar, setIsWidth } from "../../store/slice/currentStageSlice";
import { FaCircle, FaDrawPolygon, FaSlash, FaTrash } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import { setFeatureTable } from "../../store/slice/bufferSlice";
import Sketch from "@arcgis/core/widgets/Sketch";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Loader from "../../componets/Loader";
import Select from "react-select";
import { setIsBufferWidth } from "../../store/slice/currentStageSlice";
import { setIsToolsHeight } from "../../store/slice/currentStageSlice";
import GisApiServices from "../../services/GisApiServices";
import { useNavigate } from "react-router-dom";
//import Graphic from "@arcgis/core/Graphic";

function BufferTool({ onLayerSelect, view }) {


const [selectedLayer1, setSelectedLayer1] = useState(null);
const [selectedField1, setSelectedField1] = useState(null);
const [selectedFieldValue1, setSelectedFieldValue1] = useState(null);



  const [districts, setDistricts] = useState([]);
  const [districtName, setDistrictName] = useState('');
  const [ulbs, setUlbs] = useState([]);
  const [ulbName, setUlbName] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedLayer, setSelectedLayer] = useState("");
  const [selectedUlb, setSelectedUlb] = useState("");
  const [fields, setFields] = useState([]);
  const [fieldValues, setFieldValues] = useState([]);
  const [bufferDistance, setBufferDistance] = useState("");
  const [bufferUnit, setBufferUnit] = useState("");
  const [bufferFeatures, setBufferFeatures] = useState([]);
  const [bufferGraphic, setBufferGraphic] = useState(null);
  const [bufferResponseFeatures, setBufferResponseFeatures] = useState([]);
  const [selectedFieldValue, setSelectedFieldValue] = useState('');
  const [selectedField, setSelectedField] = useState('');
  const [bufferToggle, setBufferToggle] = useState("Feature Based");
  const [geometry, setGeometory] = useState();
  const [selectedSpatialRelationship, setSelectedSpatialRelationship] = useState("intersects");
  const [isLoader, setIsSetLoader] = useState(false);
  const allFeatures = [];
  const [sketchWidget, setSketchWidget] = useState(null);
  const [polylineLayer, setPolylineLayer] = useState(null);
  const [polygonLayer, setPolygonLayer] = useState(null);
  const [pointLayer, setPointLayer] = useState(null);
  const dispatch = useDispatch()
  const resetMapTrigger = useSelector((state) => state.currentStage.resetMapTrigger);
  const { isBufferWidth, isToolHeight, isSideBar, isDragTable } = useSelector((state) => state.currentStage);
  const { isTheme } = useSelector((state) => state.currentStage)
  const authData = useSelector(state => state.authToken.authData);


   


  const navigate = useNavigate();
  const layers = [
    { name: "Roads", id: 45, outFields: ["*"] },
    { name: "Rivers", id: 69, outFields: ["ulb_cd ", "name", "area", "wardno"] },
    { name: "Railway", id: 56, outFields: ["ulb_cd ", "type", "dist_cd", "wardno"] },
    { name: "Important Land Marks", id: 79, outFields: ["ulb_cd", "name", "type"] },

  ];



  console.log("isDragTable", isDragTable)

  const Bufferlayers = [
    { name: "Plot Building Structure", id: 15, outFields: ["*"] },
    { name: "Properties", id: 14, outFields: ["relation_id"] },
    { name: "Important Land Marks", id: 79, outFields: ["*"] },

  ];


  const handleToggle = (option) => {
    setBufferToggle(option)
    dispatch(setFeatureTable([]));
    handleRefresh()
    handleDeleteDrawings()
    setBufferResponseFeatures('')
    setSelectedDistrict('')
    setSelectedUlb('')
    setSelectedLayer('')
    setSelectedField('')
    setSelectedFieldValue()
    setBufferUnit('')
    setBufferDistance('')
  }


  // useEffect(() => {
  //   const fetchDistrictCodes = async () => {
  //     const url =
  //       "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5/query?where=1=1&outFields=dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson";
  //     try {
  //       const response = await fetch(url);
  //       const data = await response.json();
  //       if (data.features) {
  //         return data.features.map((feature) => feature.properties.dist_cd);
  //       }
  //     } catch (error) {
  //       console.log("Error fetching district codes:", error);
  //     }
  //     return [];
  //   };

  //   const loadDistricts = async () => {
  //     const distCodes = await fetchDistrictCodes();
  //     if (distCodes.length === 0) {
  //       console.log("No district codes found");
  //       return;
  //     }
  //     const districtLayer = new FeatureLayer({
  //       url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3"
  //     });
  //     const query = new Query();
  //     query.returnGeometry = true;
  //     query.outFields = ["dist_cd", "districtname"];
  //     query.where = `dist_cd IN (${distCodes.map((code) => `'${code}'`).join(",")})`;
  //     query.returnDistinctValues = true;
  //     try {
  //       const response = await districtLayer.queryFeatures(query);
  //       const districtNames = response.features.map(f => ({
  //         id: f.attributes.dist_cd,
  //         label: f.attributes.districtname
  //       }));
  //       districtNames.sort((a, b) => a.label.localeCompare(b.label));
  //       setDistricts(districtNames);
  //     } catch (error) {
  //       console.log("Error loading districts:", error);
  //     }
  //   };

  //   // const handleAdminUser = async () => {
  //   //   const userDistricts = [{
  //   //     id: authData?.DistrictCode,
  //   //     label: authData?.DistrictName
  //   //   }];
  //   //   setDistricts(userDistricts);
  //   //   setDistrictName(authData?.DistrictName);
  //   //   setSelectedDistrict(authData?.DistrictCode);

  //   //   const userUlbs = [{
  //   //     id: authData?.Ulb_Code,
  //   //     label: authData?.UlbName
  //   //   }];
  //   //   setUlbs(userUlbs);
  //   //   setUlbName(authData?.UlbName);
  //   //   setSelectedUlb(authData?.Ulb_Code);

  //   //   // ⬇️ Ensure district zoom finishes before ULB zoom
  //   //   await zoomToFeature(authData?.DistrictCode, "dist_cd", "3");
  //   //   await zoomToFeature(authData?.Ulb_Code, "ulb_cd", "5");
  //   // };

  //   // if (authData?.UserType != "Admin") {
  //   //   handleAdminUser();
  //   // } else {
  //   //   loadDistricts();
  //   // }
  //   loadDistricts();
  // }, []);




  // for polyline

  // useEffect(() => {
  //   if (view) {
  //     // Create a new graphics layer for polylines
  //     const layer = new GraphicsLayer();
  //     view.map.add(layer);
  //     setPolylineLayer(layer);

  //     // Create the Sketch widget
  //     const sketch = new Sketch({
  //       view: view,
  //       layer: layer,
  //       creationMode: "update"
  //     });

  //     setSketchWidget(sketch);
  //   }
  // }, [view]);


  //polygon

  // useEffect(() => {
  //   if (view) {
  //     // Create a graphics layer for drawings
  //     const layer = new GraphicsLayer();
  //     view.map.add(layer);
  //     setPolygonLayer(layer);

  //     // Create the Sketch widget
  //     const sketch = new Sketch({
  //       view: view,
  //       layer: layer,
  //       creationMode: "update"
  //     });

  //     setSketchWidget(sketch);
  //   }
  // }, [view]);

  //point

  // useEffect(() => {
  //   if (view) {
  //     const layer = new GraphicsLayer();
  //     view.map.add(layer);
  //     setPointLayer(layer);

  //     // Create the Sketch widget
  //     const sketch = new Sketch({
  //       view: view,
  //       layer: layer,
  //       creationMode: "update"
  //     });

  //     // Capture the completed geometry
  //     sketch.on("create", (event) => {
  //       if (event.state === "complete") {
  //         setGeometory(event.graphic.geometry);  // Store geometry in state
  //       }
  //     });

  //     setSketchWidget(sketch);
  //   }
  // }, [view]);


  // useEffect(() => {
  //   const fetchDistrictCodes = async () => {
  //     const url =
  //       "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5/query?where=1=1&outFields=dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson";
  //     try {
  //       const response = await fetch(url);
  //       const data = await response.json();
  //       if (data.features) {
  //         return data.features.map((feature) => feature.properties.dist_cd);
  //       }
  //     } catch (error) {
  //       console.log("Error fetching district codes:", error);
  //     }
  //     return [];
  //   };

  //   const loadDistricts = async () => {
  //     const distCodes = await fetchDistrictCodes();
  //     if (distCodes.length === 0) {
  //       console.log("No district codes found");
  //       return;
  //     }
  //     const districtLayer = new FeatureLayer({
  //       url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3"
  //     });
  //     const query = new Query();
  //     query.returnGeometry = true;
  //     query.outFields = ["dist_cd", "districtname"];
  //     query.where = `dist_cd IN (${distCodes.map((code) => `'${code}'`).join(",")})`;
  //     query.returnDistinctValues = true;
  //     try {
  //       const response = await districtLayer.queryFeatures(query);
  //       const districtNames = response.features.map(f => ({
  //         id: f.attributes.dist_cd,
  //         label: f.attributes.districtname
  //       }));
  //       districtNames.sort((a, b) => a.label.localeCompare(b.label));
  //       setDistricts(districtNames);
  //     } catch (error) {
  //       console.log("Error loading districts:", error);
  //     }
  //   };

  //   const handleAdminUser = async () => {
  //     const userDistricts = [{
  //       id: authData?.DistrictCode,
  //       label: authData?.DistrictName
  //     }];
  //     setDistricts(userDistricts);
  //     setDistrictName(authData?.DistrictName);
  //     setSelectedDistrict(authData?.DistrictCode);

  //     const userUlbs = [{
  //       id: authData?.Ulb_Code,
  //       label: authData?.UlbName
  //     }];
  //     setUlbs(userUlbs);
  //     setUlbName(authData?.UlbName);
  //     setSelectedUlb(authData?.Ulb_Code);

  //     // ⬇️ Ensure district zoom finishes before ULB zoom
  //     await zoomToFeature(authData?.DistrictCode, "dist_cd", "3");
  //     await zoomToFeature(authData?.Ulb_Code, "ulb_cd", "5");
  //   };

  //   if (authData?.UserType != "Admin") {
  //     handleAdminUser();
  //   } else {
  //     loadDistricts();
  //   }
  // }, []);


  useEffect(() => {
    const fetchDistrictCodes = async () => {
      const url =
        "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5/query?where=1=1&outFields=dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson";
      try {
        const response = await fetch(url);
        const data = await response.json();
        if (data.features) {
          return data.features.map((feature) => feature.properties.dist_cd);
        }
      } catch (error) {
        console.log("Error fetching district codes:", error);
      }
      return [];
    };

    const loadDistricts = async () => {
      const distCodes = await fetchDistrictCodes();
      if (distCodes.length === 0) {
        console.log("No district codes found");
        return;
      }
      const districtLayer = new FeatureLayer({
        url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3"
      });
      const query = new Query();
      query.returnGeometry = true;
      query.outFields = ["dist_cd", "districtname"];
      query.where = `dist_cd IN (${distCodes.map((code) => `'${code}'`).join(",")})`;
      query.returnDistinctValues = true;
      try {
        const response = await districtLayer.queryFeatures(query);
        const districtNames = response.features.map(f => ({
          id: f.attributes.dist_cd,
          label: f.attributes.districtname
        }));
        districtNames.sort((a, b) => a.label.localeCompare(b.label));
        setDistricts(districtNames);
      } catch (error) {
        console.log("Error loading districts:", error);
      }
    };

    const handleAdminUser = async () => {
      const userDistricts = [{
        id: authData?.DistrictCode,
        label: authData?.DistrictName
      }];
      setDistricts(userDistricts);
      setDistrictName(authData?.DistrictName);
      setSelectedDistrict(authData?.DistrictCode);

      const userUlbs = [{
        id: authData?.Ulb_Code,
        label: authData?.UlbName
      }];
      setUlbs(userUlbs);
      setUlbName(authData?.UlbName);
      setSelectedUlb(authData?.Ulb_Code);

      // ⬇️ Ensure district zoom finishes before ULB zoom
      await zoomToFeature(authData?.DistrictCode, "dist_cd", "3");
      await zoomToFeature(authData?.Ulb_Code, "ulb_cd", "5");
    };

    const handleDistrictUser = async () => {
      const userDistricts = [{
        id: authData?.DistrictCode,
        label: authData?.DistrictName
      }];
      setDistricts(userDistricts);
      setDistrictName(authData?.DistrictName);
      setSelectedDistrict(authData?.DistrictCode);
      loadUlbs(authData?.DistrictCode)
      // ⬇️ Ensure district zoom finishes before ULB zoom
      await zoomToFeature(authData?.DistrictCode, "dist_cd", "3");
      await zoomToFeature(authData?.Ulb_Code, "ulb_cd", "5");

    };

    if (authData?.UserType === "User") {
      handleAdminUser();
    } else if (authData?.UserType === "districtuser") {
      handleDistrictUser();
    } else {
      loadDistricts();
    }
    // loadDistricts();
    // }
  }, []);





  const handleDistrictChange = (selectedOption) => {
    setDistrictName(selectedOption?.label)
    const selected = selectedOption?.value;
    if (!selected) return;
    setSelectedDistrict(selected);
    setSelectedUlb("");
    setUlbs([]);
    setSelectedLayer("");
    setSelectedField("");
    setFields([]);
    setSelectedFieldValue("");
    setFieldValues([]);
    loadUlbs(selected);
    zoomToFeature(selected, "dist_cd", "3");
  };

  const loadUlbs = async (district) => {
    console.log("jjsdfsd", district)
    console.log("helll")
    try {
      const ulbLayer = new FeatureLayer({
        url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5"
      });
      const ulbQuery = new Query();
      ulbQuery.where = `dist_cd = '${district}'`
      ulbQuery.outFields = ["ulb_cd", "name"];
      ulbQuery.returnDistinctValues = true;
      const ulbResponse = await ulbLayer.queryFeatures(ulbQuery);
      const ulbNames = ulbResponse.features.map(f => { return { "id": f?.attributes.ulb_cd, "lable": f?.attributes.name } });
      setUlbs(ulbNames);

    } catch (error) {
      console.log("Error loading ULBs:", error);
    }

  };

  const handleUlbChange = async (selectedOption) => {
    setUlbName(selectedOption?.label)
    const selectedUlb = selectedOption?.value
    if (!selectedUlb) return;
    setSelectedUlb(selectedUlb);
    setSelectedLayer("");
    setSelectedField("");
    setFields([]);
    setSelectedFieldValue("");
    setFieldValues([]);
    if (selectedUlb) {
      zoomToFeature(selectedUlb, "ulb_cd", "5");

    }
  };

  //layers
  const handleLayerChange = async (selectedOption) => {
    try {
      view.graphics.removeAll();
      const selected = selectedOption?.label;
      setSelectedLayer(selected);
      setSelectedField("");
      setFields([]);
      setSelectedFieldValue("");
      setFieldValues([]);
      const layerDetails = layers.find((layer) => layer.name === selected);
      if (!layerDetails) {
        console.log("Layer details not found for the selected option.");
        setBufferFeatures([]);
        return;
      }
      const layer = new FeatureLayer({
        url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerDetails.id}`,
      });

      const query = new Query();
      query.where = `dist_cd = '${selectedDistrict}' AND ulb_cd = '${selectedUlb}'`;
      query.returnGeometry = true;
      query.outFields = ["*"]; // Fetch all fields

      const response = await layer.queryFeatures(query);
      if (!response.features.length) {
        toast.error("No search found in Ulbs");
        // setBufferFeatures([]);
        setSelectedLayer("")
        return;
      }

      // Extract fields from the first feature's attributes
      const fields = response.fields?.map((field) => field.name) || [];
      // const fieldsFilter = fields.filter(fields =>['name','area'].includes(fields))
      setFields(fields);
      // Convert feature geometries to serializable format
      const features = response.features.map((feature) => ({
        attributes: feature.attributes,
        geometry: feature.geometry ? feature.geometry.toJSON() : null,
      }));

      // Update buffer features
      setBufferFeatures(response.features);

      response.features.forEach((feature) => {
        if (!feature.geometry) return;

        let graphic;
        const geometryType = feature.geometry.type;

        if (geometryType === "point") {
          graphic = new Graphic({
            geometry: feature.geometry,
            symbol: {
              type: "simple-marker",
              style: "circle",
              color: [0, 0, 255, 0.5], // Blue with transparency
              size: 6,
              outline: { color: [0, 0, 255], width: 1 },
            },
          });
        } else if (["polyline", "multiline", "multipolyline"].includes(geometryType)) {
          graphic = new Graphic({
            geometry: feature.geometry,
            symbol: { type: "simple-line", color: [0, 255, 0], width: 2 }, // Green
          });
        } else if (["polygon", "multipolygon"].includes(geometryType)) {
          graphic = new Graphic({
            geometry: feature.geometry,
            symbol: {
              type: "simple-fill",
              color: [255, 255, 0, 0.5], // Yellow with transparency
              outline: { color: [255, 255, 0], width: 1 },
            },
          });
        } else {
          console.log(`Unsupported geometry type: ${geometryType}`);
          return;
        }

        view.graphics.add(graphic);
      });

      // Zoom to the first feature's centroid
      const firstFeature = response.features[0];
      if (firstFeature.geometry) {
        const center = firstFeature.geometry.centroid || firstFeature.geometry.extent?.center;
        if (center) {
          view.goTo(center);
        } else {
          console.log("Center is null or undefined.");
        }
      }
    } catch (error) {
      console.log("Error fetching or processing layer data:", error);
    }
  };

  const highlightFeatures = (features) => {
    view.graphics.removeAll(); // Clear previous highlights

    if (!features || features.length === 0) {
      console.log("No features found to highlight.");
      return;
    }

    features.forEach((feature) => {
      if (!feature.geometry) {
        console.log("Feature has no geometry:", feature);
        return;
      }

      let highlightGraphic;
      const geometryType = feature.geometry.type;

      if (geometryType === "point") {
        highlightGraphic = new Graphic({
          geometry: feature.geometry,
          symbol: {
            type: "simple-marker",
            style: "circle",
            color: [255, 0, 0, 0.5], // Red with transparency
            size: 8,
            outline: { color: [255, 0, 0], width: 2 },
          },
        });
      } else if (geometryType === "polyline") {
        highlightGraphic = new Graphic({
          geometry: feature.geometry,
          symbol: {
            type: "simple-line",
            color: [255, 0, 0], // Red
            width: 3,
          },
        });
      } else if (geometryType === "polygon") {
        highlightGraphic = new Graphic({
          geometry: feature.geometry,
          symbol: {
            type: "simple-fill",
            color: [255, 0, 0, 0.3], // Red with transparency
            outline: { color: [255, 0, 0], width: 2 },
          },
        });
      } else {
        console.log(`Unsupported geometry type: ${geometryType}`);
        return;
      }

      view.graphics.add(highlightGraphic);
    });

    // Zoom to highlighted features
    if (features[0]?.geometry) {
      view.goTo(features.map((feature) => feature.geometry?.extent?.expand(1.5))).catch(err => console.log("Error zooming:", err));
    }
  };

  const handleFieldChange = async (option) => {
    try {
      const selectedField = option?.label;
      if (!selectedField) return;

      const layerDetails = layers.find((layer) => layer.name === selectedLayer);
      if (!layerDetails) {
        console.log("Layer details not found for selected layer:", selectedLayer);
        return;
      }

      const layer = new FeatureLayer({
        url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerDetails.id}`,
      });

      const query = new Query();
      query.where = `dist_cd = '${selectedDistrict}' AND ulb_cd = '${selectedUlb}' AND ${selectedField} <> ' '`;
      query.returnDistinctValues = true;
      query.outFields = [selectedField];

      const response = await layer.queryFeatures(query);

      const values = response?.features?.map((feature) => feature?.attributes?.[selectedField]) || [];

      setFieldValues(values);
      setSelectedField(selectedField);
    } catch (error) {
      console.log("Error handling field change:", error);
    }
  };


  const handleUniteValueChange = (option) => {
    setBufferUnit(option?.label)
  }

  const handleSpatislRelation = (option) => {
    if (option?.label === 'Completely inside') {
      setSelectedSpatialRelationship('contains')
    } else if (option?.label === 'Intersects') {
      setSelectedSpatialRelationship('intersects')
    } else {
      setSelectedSpatialRelationship('intersects')
    }
  }

  const handleFieldValueChange = async (value) => {
    const selectedValue = value?.label;
    if (!selectedValue) return;

    setSelectedFieldValue(selectedValue);

    const layerDetails = layers.find(layer => layer.name === selectedLayer);
    if (!layerDetails) return;

    const layer = new FeatureLayer({
      url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerDetails.id}`,
    });

    const query = new Query();
    query.where = `dist_cd = '${selectedDistrict}' AND ulb_cd = '${selectedUlb}' AND ${selectedField} = '${selectedValue}'`;
    query.returnGeometry = true;

    try {
      const response = await layer.queryFeatures(query);

      if (response.geometryType === "polyline") {
        let paths = [];
        response.features.forEach((featutre) => {
          featutre.geometry.paths.forEach((path) => {
            paths.push(path);
          });
        });

        var polyline = {
          type: "polyline",
          paths: paths,
          spatialReference: { wkid: 4326 }
        };
        var feature = new Graphic({
          geometry: polyline,
        });
        setGeometory(polyline);
        highlightFeatures([feature]);
      } 
      else 

        if (response.geometryType === "polygon") {
  let rings = [];

  response.features.forEach((feature) => {
    feature.geometry.rings.forEach((ring) => {
      rings.push(ring);
    });
  });

  const polygon = {
    type: "polygon",
    rings: rings,
    spatialReference: { wkid: 4326 }
  };

  const feature = new Graphic({
    geometry: polygon
  });

  setGeometory(polygon);
  highlightFeatures([feature]);
}
 else {
        
        setGeometory(response.features[0].geometry);
        highlightFeatures(response.features);

      }




    } catch (error) {
      console.log("Error querying features:", error);
    }
  };

  // const handleBufferButtonClick = useCallback(async () => {
  //   if (!bufferDistance || !bufferUnit || !selectedLayer) return;

  //   // Remove existing buffer graphics
  //   if (bufferGraphic) {
  //     view.graphics.remove(bufferGraphic);
  //     setBufferGraphic(null);

  //   }

  //   if (bufferResponseFeatures?.length) {
  //     bufferResponseFeatures.forEach(feature => view.graphics.remove(feature));
  //   }

  //   const spatialReference = new SpatialReference({ wkid: 3857 });
  //   const projectedGeometry = project(geometry, spatialReference);
  //   if (!projectedGeometry) return console.log("Failed to project geometry.");

  //   const unitMap = { meters: "meters", kilometers: "kilometers", miles: "miles" };
  //   const unit = unitMap[bufferUnit];

  //   const bufferGeometry = geometryEngineBuffer(projectedGeometry, parseFloat(bufferDistance), unit);
  //   if (!bufferGeometry) return console.log("Failed to create buffer.");

  //   const _bufferGraphic = new Graphic({
  //     geometry: bufferGeometry,
  //     symbol: { type: "simple-fill", color: null, outline: { color: [0, 0, 255], width: 2 } },
  //   });

  //   view.graphics.add(_bufferGraphic);
  //   setBufferGraphic(_bufferGraphic);

  //   let bufferData = [];
  //   let graphics = [];
  //   let allFeatures = [];

  //   await Promise.all(Bufferlayers.map(async (bufferLayer) => {
  //     const bufferLayerInstance = new FeatureLayer({
  //       url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${bufferLayer.id}`,
  //     });

  //     const bufferQuery = new Query({
  //       geometry: bufferGeometry,
  //       spatialRelationship: selectedSpatialRelationship,
  //       returnGeometry: true,
  //       outFields: bufferLayer.outFields,
  //     });

  //     const bufferResponse = await bufferLayerInstance.queryFeatures(bufferQuery);
  //     const features = bufferResponse?.features || [];

  //     bufferData.push({ layer: bufferLayer.name, features: features.map(f => f.attributes) });

  //     console.log("featuresfeatures", features)

  //     if (bufferLayer.id == "14") {


  //       // Extract relation_id values
  //       const relationIds = features
  //         .map(feature => feature.attributes?.relation_id)
  //         .filter(id => id) 
  //         .map(id => `'${id}'`) 
  //         .slice(0, 20)
  //         .join(","); 

  //       console.log("relationIdsrelationIds", relationIds.length)




  //       if (relationIds) {
  //         console.log("Generated relation_id Query String:", relationIds);
  //         // setIsSetLoader(true)
  //         const updateData = await getNewTableData(relationIds, selectedUlb);
  //         console.log("Fetched Data for bufferLayer 14:", updateData);

  //         if (!Array.isArray(updateData) || updateData.length === 0) {
  //           console.log("No valid data fetched from API.");
  //           return;
  //         }

  //         // Merge API Data into Features
  //         const updatedFeatures = features.map((feature) => {
  //           const relationId = feature.attributes?.relation_id?.toString();
  //           const newData = updateData.find(item => item.gis_uniqueid?.toString() === relationId);

  //           return newData
  //             ? { ...feature, attributes: { ...feature.attributes, ...newData } }
  //             : feature;
  //         });

  //         console.log("Updated Features for bufferLayer 14:", updatedFeatures);

  //         // ✅ Log Dispatch Data
  //         console.log("🚀 Dispatching Data:", {
  //           bufferId: bufferLayer.id,
  //           features: updatedFeatures,
  //           properties: updateData
  //         });

  //         dispatch(setBufferData({ bufferId: bufferLayer.id, features: updatedFeatures, properties: updateData }));
  //         dispatch(setIsWidth(true));
  //         // dispatch(setBufferData({ bufferId: bufferLayer.id, features  }));
  //         // dispatch(setIsWidth(true));
  //       } else {
  //         console.log("No valid relation_id values found.");
  //       }

  //     }

  //     allFeatures.push(...features);

  //     // Add Graphics
  //     features.forEach(feature => {
  //       const symbolMap = {
  //         point: { type: "simple-marker", style: "circle", color: [255, 0, 0, 0.5], size: 6, outline: { color: [0, 0, 0, 1], width: 1 } },
  //         polyline: { type: "simple-line", color: [0, 255, 0, 0.5], width: 2 },
  //         polygon: { type: "simple-fill", color: [128, 255, 0, 0.5], outline: { color: [0, 0, 0, 1], width: 1 } },
  //         multipolygon: { type: "simple-fill", color: [255, 0, 255, 0.5], outline: { color: [0, 0, 0, 1], width: 1 } },
  //       };

  //       if (!symbolMap[feature.geometry.type]) return;

  //       const graphic = new Graphic({ geometry: feature.geometry, symbol: symbolMap[feature.geometry.type] });
  //       graphics.push(graphic);
  //       view.graphics.add(graphic);
  //     });
  //   }));

  //   setBufferResponseFeatures(graphics);
  //   dispatch(setFeatureTable(bufferData));

  // }, [bufferDistance, bufferUnit, selectedLayer, view, bufferGraphic, bufferResponseFeatures, Bufferlayers, dispatch]);

  // const handleBufferButtonClick = useCallback(async () => {
  //   if (!bufferDistance || !bufferUnit || !selectedLayer) return;

  //   // Remove existing buffer graphics
  //   if (bufferGraphic) {
  //     view.graphics.remove(bufferGraphic);
  //     setBufferGraphic(null);
  //   }

  //   if (bufferResponseFeatures?.length) {
  //     bufferResponseFeatures.forEach(feature => view.graphics.remove(feature));
  //   }

  //   const spatialReference = new SpatialReference({ wkid: 3857 });
  //   const projectedGeometry = project(geometry, spatialReference);
  //   if (!projectedGeometry) return console.log("Failed to project geometry.");

  //   const unitMap = { meters: "meters", kilometers: "kilometers", miles: "miles" };
  //   const unit = unitMap[bufferUnit];

  //   const bufferGeometry = geometryEngineBuffer(projectedGeometry, parseFloat(bufferDistance), unit);
  //   if (!bufferGeometry) return console.log("Failed to create buffer.");

  //   const _bufferGraphic = new Graphic({
  //     geometry: bufferGeometry,
  //     symbol: { type: "simple-fill", color: null, outline: { color: [0, 0, 255], width: 2 } },
  //   });

  //   view.graphics.add(_bufferGraphic);
  //   setBufferGraphic(_bufferGraphic);

  //   let bufferData = [];
  //   let graphics = [];
  //   let allFeatures = [];
  //   let allRelationIds = [];

  //   await Promise.all(Bufferlayers.map(async (bufferLayer) => {
  //     const bufferLayerInstance = new FeatureLayer({
  //       url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${bufferLayer.id}`,
  //     });

  //     const bufferQuery = new Query({
  //       geometry: bufferGeometry,
  //       spatialRelationship: selectedSpatialRelationship,
  //       returnGeometry: true,
  //       outFields: bufferLayer.outFields,
  //     });

  //     const bufferResponse = await bufferLayerInstance.queryFeatures(bufferQuery);
  //     const features = bufferResponse?.features || [];

  //     bufferData.push({ layer: bufferLayer.name, features: features.map(f => f.attributes) });

  //     if (bufferLayer.id == "14") {

  //       const relationIds = features
  //         .map(feature => feature.attributes?.relation_id)
  //         .filter(id => id) // Remove null/undefined values
  //         .map(id => `${id}`); // Wrap IDs in single quotes


  //       const updateData = await getNewTableData(relationIds, selectedUlb);

  //       // if (relationIds.length > 0) {
  //       //   localStorage.setItem("relationIds", JSON.stringify(relationIds));
  //       //   localStorage.setItem("selectedUlb", selectedUlb);
  //       //   console.log("Saved relation_ids to localStorage:", relationIds.length);
  //       // }


  //       // const limitedRelationIds = relationIds.slice(0, 10).join(",");
  //       // console.log("Sending first 100 relation_ids:", limitedRelationIds);

  //       // if (limitedRelationIds) {

  //       console.log("updateDataupdateData", updateData)
  //       console.log("updateData", updateData)
  //       if (!Array.isArray(updateData) || updateData.length === 0) {
  //         console.log("No valid data fetched from API.");
  //         return;
  //       }


  //       const updatedFeatures = features.map((feature) => {
  //         const relationId = feature.attributes?.relation_id?.toString();
  //         const newData = updateData.find(item => item.gis_uniqueid?.toString() === relationId);

  //         return newData
  //           ? { ...feature, attributes: { ...feature.attributes, ...newData } }
  //           : feature;
  //       });


  //       dispatch(setBufferData({ bufferId: bufferLayer.id, features: updatedFeatures, properties: updateData, selectedUlb: selectedUlb }));;
  //       dispatch(setIsBufferWidth(isBufferWidth))
  //       dispatch(setIsToolsHeight(isToolHeight))
  //       dispatch(setIsSidebar(isSideBar))
  //       // } else {
  //       //   console.log("No valid relation_id values found.");
  //       // }
  //     }

  //     allFeatures.push(...features);

  //     // Add Graphics
  //     features.forEach(feature => {
  //       const symbolMap = {
  //         point: { type: "simple-marker", style: "circle", color: [255, 0, 0, 0.5], size: 6, outline: { color: [0, 0, 0, 1], width: 1 } },
  //         polyline: { type: "simple-line", color: [0, 255, 0, 0.5], width: 2 },
  //         polygon: { type: "simple-fill", color: [128, 255, 0, 0.5], outline: { color: [0, 0, 0, 1], width: 1 } },
  //         multipolygon: { type: "simple-fill", color: [255, 0, 255, 0.5], outline: { color: [0, 0, 0, 1], width: 1 } },
  //       };

  //       if (!symbolMap[feature.geometry.type]) return;

  //       const graphic = new Graphic({ geometry: feature.geometry, symbol: symbolMap[feature.geometry.type] });
  //       graphics.push(graphic);
  //       view.graphics.add(graphic);
  //     });
  //   }));

  //   setBufferResponseFeatures(graphics);
  //   dispatch(setFeatureTable(bufferData));

  // }, [bufferDistance, bufferUnit, selectedLayer, view, bufferGraphic, bufferResponseFeatures, Bufferlayers, dispatch]);




  // const getNewTableData = async (relationIds, selectedUlb) => {
  //   if (!relationIds || !selectedUlb) {
  //     console.log("No relationIds or selectedUlb provided!");
  //     return [];
  //   }


  //   try {
  //     const encodedIds = encodeURIComponent(`${relationIds}`);
  //     const encodedUlb = encodeURIComponent(selectedUlb); // Encode ULB code

  //     const apiUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/FeatureServer/96/query?where=ulb_cd%3D%27${encodedUlb}%27+and+relation_id+in+%28${encodedIds}%29&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&defaultSR=&spatialRel=esriSpatialRelRelation&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnCentroid=false&timeReferenceUnknownClient=false&maxRecordCountFactor=&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=&cacheHint=false&f=pjson`
  //     console.log("apiUrlapiUrl",apiUrl)
  //     // Fetch API Data
  //     const response = await fetch(apiUrl);
  //     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

  //     const data = await response.json();
  //     // if (data) {
  //     //   setIsSetLoader(false);
  //     // }

  //     return data.features?.map(f => f.attributes) || [];
  //   } catch (error) {
  //     console.log("Error fetching data:", error);
  //     return [];
  //   }
  // };

  const userLogActivity = async () => {
    try {
      const authToken = localStorage.getItem('token');
      if (!authToken) {
        console.error("No auth token found");
        navigate("/login");
        return;
      }
      const value = {
        userId: authData?.UserID,
        logActivity: "Buffer Analysis",
        logModule: "GIS Dashboard",
        logType: "Access",
        loginToken: ""
      }
      const config = {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      };
      const response = await GisApiServices.createLog(value, config);
      const data = response.data?.data || [];
      console.log("data", data)
    } catch (error) {
      console.error("Error fetching departments", error);
    } finally {
    }
  };

  // CODE BHUPEN 26MAy
  
  const handleBufferButtonClick = useCallback(async () => {

    
    //  alert("CALL handleBufferButtonClick ");
    if (!bufferDistance || !bufferUnit || !selectedLayer) return;

    // Remove existing buffer graphics
    if (bufferGraphic) {
      view.graphics.remove(bufferGraphic);
      setBufferGraphic(null);
    }

    // if (bufferResponseFeatures?.length) {
    //   bufferResponseFeatures.forEach(feature => view.graphics.remove(feature));
    // }

    //  alert("26MAY BHUPEN DATA ");
    // console.log(geometry);
        

  // If you want alert
  // alert(JSON.stringify(geometry));
    
    const spatialReference = new SpatialReference({ wkid: 3857 });
    const projectedGeometry = project(geometry, spatialReference);
    if (!projectedGeometry) return console.log("Failed to project geometry.");

    const unitMap = { meters: "meters", kilometers: "kilometers", miles: "miles" };
    const unit = unitMap[bufferUnit];

    const bufferGeometry = geometryEngineBuffer(projectedGeometry, parseFloat(bufferDistance), unit);
    if (!bufferGeometry) return console.log("Failed to create buffer.");

    const _bufferGraphic = new Graphic({
      geometry: bufferGeometry,
      symbol: { type: "simple-fill", color: null, outline: { color: [0, 0, 255], width: 2 } },
    });

    view.graphics.add(_bufferGraphic);
    setBufferGraphic(_bufferGraphic);

    let bufferData = [];
    let graphics = [];
    let allFeatures = [];
    let allRelationIds = [];

    await userLogActivity()

    await Promise.all(Bufferlayers.map(async (bufferLayer) => {
      const bufferLayerInstance = new FeatureLayer({
        url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${bufferLayer.id}`,
      });

      const bufferQuery = new Query({
        geometry: bufferGeometry,
        spatialRelationship: selectedSpatialRelationship,
        returnGeometry: true,
        outFields: bufferLayer.outFields,
      });

      const bufferResponse = await bufferLayerInstance.queryFeatures(bufferQuery);
      const features = bufferResponse?.features || [];

      bufferData.push({ layer: bufferLayer.name, features: features.map(f => f.attributes) });

      if (bufferLayer.id == "14") {

        const relationIds = features
          .map(feature => feature.attributes?.relation_id)
          .filter(id => id) // Remove null/undefined values
          .map(id => `${id}`); // Wrap IDs in single quotes


        const updateData = await getNewTableData(relationIds, selectedUlb);
        const updateDataRes = updateData.data

        console.log("updateDataupdateData", updateDataRes)
        console.log("updateData", updateDataRes)
        if (!Array.isArray(updateDataRes) || updateDataRes.length === 0) {
          console.log("No valid data fetched from API.");
          return;
        }


        const updatedFeatures = features.map((feature) => {
          const relationId = feature.attributes?.relation_id?.toString();
          const newData = updateDataRes.find(item => item.gis_uniqueid?.toString() === relationId);

          return newData
            ? { ...feature, attributes: { ...feature.attributes, ...newData } }
            : feature;
        });

        console.log("updatedFeatures", updatedFeatures)


        dispatch(setBufferData({ bufferId: bufferLayer.id, features: updatedFeatures, properties: updateDataRes, selectedUlb: selectedUlb }));
        dispatch(setIsBufferWidth(isBufferWidth))
        dispatch(setIsToolsHeight(isToolHeight))
        dispatch(setIsSidebar(isSideBar))
        // } else {
        //   console.log("No valid relation_id values found.");
        // }
      }

      allFeatures.push(...features);

      // Add Graphics
      features.forEach(feature => {
        const symbolMap = {
          point: { type: "simple-marker", style: "circle", color: [255, 0, 0, 0.5], size: 6, outline: { color: [0, 0, 0, 1], width: 1 } },
          polyline: { type: "simple-line", color: [0, 255, 0, 0.5], width: 2 },
          polygon: { type: "simple-fill", color: [128, 255, 0, 0.5], outline: { color: [0, 0, 0, 1], width: 1 } },
          multipolygon: { type: "simple-fill", color: [255, 0, 255, 0.5], outline: { color: [0, 0, 0, 1], width: 1 } },
        };

        if (!symbolMap[feature.geometry.type]) return;

        const graphic = new Graphic({ geometry: feature.geometry, symbol: symbolMap[feature.geometry.type] });
        graphics.push(graphic);
        view.graphics.add(graphic);
      });
    }));

    setBufferResponseFeatures(graphics);
    dispatch(setFeatureTable(bufferData));

  }, [bufferDistance, bufferUnit, selectedLayer, view, bufferGraphic, bufferResponseFeatures, Bufferlayers, dispatch]);




//[bufferDistance, bufferUnit, selectedLayer, view, bufferGraphic, 
// bufferResponseFeatures, Bufferlayers, dispatch]);



  // const getNewTableData = async (relationIds, selectedUlb) => {
  //   console.log("relationIds, selectedUlb", relationIds, selectedUlb)
  //   if (!relationIds || !selectedUlb) {
  //     console.log("No relationIds or selectedUlb provided!");
  //     return [];
  //   }
  //   try {
  //     const response = await GisApiServices.mistDetails({ relationIds, selectedUlb });
  //     return response.data;
  //   } catch (error) {
  //     if (error.response) {
  //       console.error('Server responded with an error:', error.response.data);
  //       console.error('Status code:', error.response.status);
  //     } else if (error.request) {
  //       console.error('No response received:', error.request);
  //     } else {
  //       console.error('Error setting up request:', error.message);
  //     }

  //     return [];
  //   }

  // };

  const getNewTableData = async (relationIds, selectedUlb) => {
    const authToken = localStorage.getItem('token');
    if (!relationIds || !selectedUlb) {
      console.log("No relationIds or selectedUlb provided!");
      return [];
    }
    if (!authToken) {
      console.error("No auth token found");
      return;
    }
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await GisApiServices.mistDetails({ relationIds, selectedUlb }, config);

      return response.data;
    } catch (error) {
      console.error('Error fetching table data:', error);
      return [];
    }
  };


  const handleRefresh = () => {
    setSelectedDistrict([]);
    setSelectedUlb('');
    setSelectedLayer([]);
    setBufferDistance('');
    setBufferUnit('');
    setFieldValues([]);
    setUlbs([])
    setUlbName("")
    dispatch(setFeatureTable([]));
    setDistrictName("")
    setSelectedLayer("")
    setSelectedField("")
    setFieldValues([])
    setFields([])
    setFieldValues([])
    setSelectedFieldValue('')
    view.graphics.removeAll();
    setSelectedSpatialRelationship("")
    view.goTo({
      center: [78.746567, 23.83403], // Longitude, Latitude
      zoom: 7 // Adjust zoom level as needed
    });
  }

  useEffect(() => {
    view.graphics.removeAll();
    view.goTo({
      center: [77.4126, 23.2599], // Longitude, Latitude
      zoom: 6 // Adjust zoom level as needed
    });
  }, [resetMapTrigger]); // Dependency on resetMapTrigger


  // const zoomToFeature = async (value, fieldName, layerId) => {
  //   try {
  //     const layer = new FeatureLayer({
  //       url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerId}`
  //     });

  //     const query = new Query();
  //     query.where = `${fieldName} = '${value}'`;
  //     query.returnGeometry = true;

  //     const response = await layer.queryFeatures(query);
  //     const geometry = response?.features?.[0]?.geometry;

  //     if (!geometry) {
  //       console.log(`No features found for ${fieldName}: ${value}`);
  //       return;
  //     }

  //     const graphic = new Graphic({
  //       geometry,
  //       symbol: {
  //         type: "simple-fill",
  //         color: null,
  //         outline: { color: [0, 0, 255], width: 2 }
  //       }
  //     });

  //     view?.graphics?.add(graphic);

  //     view?.goTo({
  //       target: graphic.geometry?.extent,
  //       zoom: (view?.zoom ?? 0) + 4 // Increase zoom level safely
  //     });

  //   } catch (error) {
  //     console.log(`Error zooming to feature: ${value}`, error);
  //   }
  // };

  //Polyline

//26MAY
  const zoomToFeature = async (value, fieldName, layerId) => {
    try {
      const layer = new FeatureLayer({
        url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerId}`
      });

    setSelectedLayer1(layer);

    setSelectedField1(fieldName);

    setSelectedFieldValue1(value);


const query = new Query();

query.where = `${fieldName} = '${value}'`;
query.returnGeometry = true;
query.outFields = ["*"];

const response = await layer.queryFeatures(query);

// All features
const feature = response.features;

console.log(feature);


      // UNIon 26MAY
      if (!feature?.geometry) {
        console.log(` No features found for ${fieldName}: ${value}`);
        return;
      }
      else
      {
          console.log(`BHUPEN UNION 26MAY  ${fieldName}: ${value}`);
      }

      const graphic = new Graphic({
        geometry: feature.geometry,
        symbol: {
          type: "simple-fill",
          color: null,
          outline: { color: [0, 0, 255], width: 2 }
        }
      });

      view?.graphics?.add(graphic);

      // Handle zoom logic based on geometry type
      if (feature.geometry.type === "point") {
        await view.goTo({
          target: feature.geometry,
          zoom: 17 // You can adjust this zoom level as needed
        });
      } else {
        const extent = feature.geometry.extent || feature.geometry;
        await view.goTo({
          target: extent.expand(1.5) // Optionally buffer the extent a bit
        });
      }
      // Handle zoom logic based on geometry type
      if (feature.geometry.type === "point") {
        await view.goTo({
          target: feature.geometry,
          zoom: 17 // You can adjust this zoom level as needed
        });
      } else {
        const extent = feature.geometry.extent || feature.geometry;
        await view.goTo({
          target: extent.expand(1.5) // Optionally buffer the extent a bit
        });
      }

    } catch (error) {
      console.log(`Error zooming to feature: ${value}`, error);
    }
  };


  const handleDrawPolyline = () => {
    if (!sketchWidget || !polylineLayer) return;

    // Clear existing graphics before drawing a new polyline
    polylineLayer.removeAll();

    // Listen for the create event
    sketchWidget.on("create", (event) => {
      if (event.state === "complete") {
        console.log("Polyline Geometry:", event.graphic.geometry);
      }
    });

    // Enable polyline drawing mode
    sketchWidget.create("polyline");
  };
  //Polygon

  const handleDrawPolygon = (geometryType) => {
    if (!sketchWidget || !polygonLayer) return;

    // Clear previous drawings
    polygonLayer.removeAll();

    // Listen for the create event
    sketchWidget.on("create", (event) => {
      if (event.state === "complete") {
        console.log("Polygon Geometry:", event.graphic.geometry);
      }
    });

    // Start drawing based on type (polyline or polygon)
    sketchWidget.create("polygon");
  };


  //point

  const handleDrawPoint = () => {
    if (!sketchWidget || !pointLayer) return;

    // Clear previous drawings
    pointLayer.removeAll();

    // Listen for the create event
    sketchWidget.on("create", (event) => {
      if (event.state === "complete") {
        console.log("Point Geometry:", event.graphic.geometry);
      }
    });

    // Start drawing based on type (polyline or polygon)
    sketchWidget.create("point");



  };
  //delete

  const handleDeleteDrawings = () => {
    if (polylineLayer) polylineLayer.removeAll();
    if (polygonLayer) polygonLayer.removeAll();
    if (pointLayer) pointLayer.removeAll();
  };

  const handleGetBuffer = useCallback(async () => {
    if (!geometry) return toast.error("Please draw a point first.");
    if (!bufferDistance || isNaN(bufferDistance)) return toast.error("Please enter a valid buffer distance.");

    // Define buffer unit
    const unitMap = { meters: "meters", kilometers: "kilometers", miles: "miles" };
    const unit = unitMap[bufferUnit];

    // Remove existing buffer graphics
    if (bufferGraphic) {
      view.graphics.remove(bufferGraphic);
      setBufferGraphic(null);
    }
    if (bufferResponseFeatures?.length) {
      bufferResponseFeatures.forEach(feature => view.graphics.remove(feature));
    }

    // Project geometry to spatial reference
    const spatialReference = new SpatialReference({ wkid: 3857 });
    const projectedGeometry = project(geometry, spatialReference);
    if (!projectedGeometry) return console.log("Failed to project geometry.");

    // Create buffer geometry
    const bufferGeometry = geometryEngineBuffer(projectedGeometry, parseFloat(bufferDistance), unit);
    if (!bufferGeometry) return console.log("Failed to create buffer.");

    // Define and add buffer graphic
    const _bufferGraphic = new Graphic({
      geometry: bufferGeometry,
      symbol: { type: "simple-fill", color: null, outline: { color: [0, 0, 255], width: 2 } },
    });
    view.graphics.add(_bufferGraphic);
    setBufferGraphic(_bufferGraphic);

    let bufferData = [];
    let graphics = [];

    await Promise.all(Bufferlayers.map(async (bufferLayer) => {
      try {
        const bufferLayerInstance = new FeatureLayer({
          url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${bufferLayer.id}`,
        });

        const bufferQuery = new Query({
          geometry: bufferGeometry,
          spatialRelationship: selectedSpatialRelationship,
          returnGeometry: true,
          outFields: bufferLayer.outFields,
        });

        const bufferResponse = await bufferLayerInstance.queryFeatures(bufferQuery);
        const features = bufferResponse?.features || [];
        bufferData.push({ layer: bufferLayer.name, features: features.map(f => f.attributes) });


        const relationIds = features
          .map(f => f.attributes?.relation_id)
          .filter(Boolean)
          .map(id => `'${id}'`)
          .join(",");
        console.log("relationIdsrelationIds", relationIds)
        if (relationIds) {
          const updateData = await getNewTableData(relationIds, selectedUlb);
          if (Array.isArray(updateData) && updateData.length > 0) {
            const updatedFeatures = features.map(feature => {
              const relationId = feature.attributes?.relation_id?.toString();
              const newData = updateData.find(item => item.gis_uniqueid?.toString() === relationId);
              return newData ? { ...feature, attributes: { ...feature.attributes, ...newData } } : feature;
            });
            console.log("updatedFeaturesupdatedFeatures", updatedFeatures)
            dispatch(setBufferData({ bufferId: bufferLayer.id, features: updatedFeatures, properties: updateData }));
            dispatch(setIsWidth(true));
          }
        }


        // Add graphics
        features.forEach(feature => {
          const symbolMap = {
            point: { type: "simple-marker", style: "circle", color: [255, 0, 0, 0.5], size: 6, outline: { color: [0, 0, 0, 1], width: 1 } },
            polyline: { type: "simple-line", color: [0, 255, 0, 0.5], width: 2 },
            polygon: { type: "simple-fill", color: [128, 255, 0, 0.5], outline: { color: [0, 0, 0, 1], width: 1 } },
            multipolygon: { type: "simple-fill", color: [255, 0, 255, 0.5], outline: { color: [0, 0, 0, 1], width: 1 } },
          };

          if (!symbolMap[feature.geometry.type]) return;
          const graphic = new Graphic({ geometry: feature.geometry, symbol: symbolMap[feature.geometry.type] });
          graphics.push(graphic);
          view.graphics.add(graphic);
        });
      } catch (error) {
        console.error(`Error processing buffer layer ${bufferLayer.name}:`, error);
      }
    }));

    setBufferResponseFeatures(graphics);
    dispatch(setFeatureTable(bufferData));
  }, [geometry, bufferDistance, bufferUnit, Bufferlayers, view, bufferGraphic, bufferResponseFeatures, dispatch]);








  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
      borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
      "&:hover": {
        borderColor: "#ccc",
      },
      fontSize: "12px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#d1ede9"
        : state.isFocused
          ? "#d1ede9"
          : "#FFFFFF",
      color: "#000",
      fontSize: "12px",
      padding: "10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000",
      fontSize: "12px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#000",
      fontSize: "12px",
    }),
    input: (provided) => ({
      ...provided,
      color: "#000",
      fontSize: "12px",
    }),
  };

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />



      <Loader isLoader={isLoader} />
      <div className="tooltitlediv linear-gradian-bg">
        <h6 className='tools-title text-white m-0'>Buffer Analysis</h6>
      </div>
      <div className="buffertogglediv">
        <button
          onClick={() => handleToggle("Feature Based")}
          className={`${bufferToggle === "Feature Based"
            ? "btn-is-feature"
            : "btn-feature"
            }`}
        >
          Feature Based
        </button>
        <button
          onClick={() => handleToggle("Drawing Based")}
          className={`${bufferToggle === "Drawing Based"
            ? "btn-is-feature"
            : "btn-feature"
            }`}
        >
          Drawing Based
        </button>
      </div>

      {bufferToggle === "Drawing Based" ?
        <>


          <div>
            <div className="mt-2">
              <label className="lebel-card-text">Select District</label>
              <Select
                options={districts.map((district) => ({
                  value: district.id,
                  label: district.label,
                }))}
                value={districtName ? { label: districtName } : null}
                onChange={(selectedOption) => {
                  if (!selectedOption) {
                    handleRefresh();
                  } else {
                    handleDistrictChange(selectedOption)
                  }
                }
                }
                placeholder="Select District"
                isClearable={true}
                styles={customStyles}
                // className="mt-2"
                isDisabled={authData?.UserType === "User" || authData?.UserType === "districtuser"}
              />
            </div>
            <div className="mt-2">
              <label className="lebel-card-text">Select Ulbs</label>
              <Select
                options={ulbs.map((ulbs) => ({
                  value: ulbs.id,
                  label: ulbs.lable,
                }))}
                value={ulbName ? { label: ulbName } : null}
                onChange={(selectedOption) =>
                  handleUlbChange(selectedOption)
                }
                placeholder="Select Ulbs"
                isClearable={true}
                styles={customStyles}
                // className="mt-2"
                isDisabled={!districtName || authData?.UserType === "User"}
              />
            </div>
            <div className="mt-2">
              <label className="lebel-card-text mt-2 mb-2">Drawing Tool</label>
              <div className="d-flex flex-wrap gap-2 mt-2">
                <div className="d-flex gap-2 w-100">
                  <Button variant="outline-primary" className="d-flex align-items-center" onClick={handleDrawPoint}>
                    <FaCircle className="me-2" /> Point
                  </Button>
                  <Button variant="outline-success" className="d-flex align-items-center" onClick={handleDrawPolyline}>
                    <FaSlash className="me-2" /> PolyLine
                  </Button>
                </div>
                <div className="d-flex gap-2 w-100">
                  <Button variant="outline-danger" className="d-flex align-items-center" onClick={handleDrawPolygon}>
                    <FaDrawPolygon className="me-2" /> Polygon
                  </Button>
                  <Button variant="outline-secondary" className="d-flex align-items-center" onClick={handleDeleteDrawings}>
                    <FaTrash className="me-2" /> Delete
                  </Button>
                </div>
              </div>
            </div>
            <div className="mt-2">
              <label className='lebel-card-text mt-2 mb-2'>Buffer Distance</label>
              <input
                id="buffer-distance"
                type="number"
                min="0"
                step="any"
                value={bufferDistance}
                onChange={(e) => setBufferDistance(e.target.value)}
                placeholder="Enter buffer distance"
                className="form-control buffer-form-control"
                disabled={!ulbName}
                style={{
                  backgroundColor: isTheme === 'light' ? '#F5F5F5' : '#002864',
                  color: isTheme === 'light' ? '#000000' : 'white',
                }}
              />
            </div>
            <div className="mt-2">
              <label className="lebel-card-text">Select Unit</label>
              <Select
                options={['Meters', 'kilometers', 'miles'].map((values) => ({
                  label: values
                }))}
                value={bufferUnit ? { label: bufferUnit } : null}
                onChange={(selectedOption) =>
                  handleUniteValueChange(selectedOption)
                }
                placeholder="Select Unit"
                isClearable={true}
                isDisabled={!bufferDistance}
                styles={customStyles}
              // className="mt-2"
              />
            </div>
            <div className="mt-2">
              <label className="lebel-card-text">Select Spatial Relation</label>
              <Select
                options={['Intersects', 'Completely inside'].map((values) => ({
                  label: values
                }))}
                value={selectedSpatialRelationship ? { label: selectedSpatialRelationship } : null}
                onChange={(selectedOption) =>
                  handleSpatislRelation(selectedOption)
                }
                placeholder="Spatial Relation"
                isClearable={true}
                styles={customStyles}
                // className="mt-2"
                isDisabled={!bufferUnit}
              />
            </div>

            <div className='buffer-btndiv'>
              <button
                className="btn-refresh"
                onClick={handleRefresh}
                style={{ marginTop: "10px" }}
              >
                {isTheme === 'light' ?
                  <img src="img/refreshlight.svg" alt="refresh" width="20px" height="20px" />
                  :
                  <img src="img/refresh.svg" alt="refresh" />
                }
                Refresh
              </button>
              <button
                className={!bufferDistance || !bufferUnit || !selectedDistrict ? "btn-comman btn-runtax comman-text" : "btn-adddestination"}
                onClick={handleGetBuffer}

                style={{ marginTop: "10px", background: " linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)", color: "white" }}

                disabled={!bufferDistance || !bufferUnit || !selectedDistrict}
              >
                Create Buffer
              </button>
            </div>
          </div>
        </>
        :
        bufferToggle === "Feature Based" ?
          <>
            <div>
              <label className="lebel-card-text mt-1">Select District</label>
              <Select
                options={districts.map((district) => ({
                  value: district.id,
                  label: district.label,
                }))}
                value={districtName ? { label: districtName } : null}
                onChange={(selectedOption) => {
                  if (!selectedOption) {
                    handleRefresh();
                  } else {
                    handleDistrictChange(selectedOption)
                  }
                }
                }
                placeholder="Select District"
                isClearable={true}
                styles={customStyles}
                // className="mt-2"
                isDisabled={authData?.UserType === "User" || authData?.UserType === "districtuser"}
              />
            </div>
            <div className="mt-2">
              <label className="lebel-card-text">Select Ulbs</label>
              <Select
                options={ulbs.map((ulbs) => ({
                  value: ulbs.id,
                  label: ulbs.lable,
                }))}
                value={ulbName ? { label: ulbName } : null}
                onChange={(selectedOption) => {
                  handleUlbChange(selectedOption)
                }
                }
                placeholder="Select Ulbs"
                isClearable={true}
                styles={customStyles}
                // className="mt-2"
                isDisabled={!districtName || authData?.UserType === "User"}
              />
            </div>

            {/* <Select
              options={districts.map((district) => ({
                value: district.id,
                label: district.label,
              }))}
              value={districtName ? { label: districtName } : null}
              onChange={(selectedOption) => {
                if (authData?.UserType === "Admin") {
                  if (!selectedOption) {
                    handleRefresh();
                  } else {
                    handleDistrictChange(selectedOption)
                  }
                }
              }
              }
              placeholder="Select District"
              isClearable={true}
              styles={customStyles}
              className="mt-2"
              isDisabled={authData?.UserType !== "Admin"}
            />

            <Select
              options={ulbs.map((ulbs) => ({
                value: ulbs.id,
                label: ulbs.lable,
              }))}
              value={ulbName ? { label: ulbName } : null}
              onChange={(selectedOption) => {
                if (authData?.UserType === "Admin") {
                  handleUlbChange(selectedOption)
                }
              }
              }
              placeholder="Select Ulbs"
              isClearable={true}
              styles={customStyles}
              className="mt-2"
              isDisabled={!districtName || authData?.UserType !== "Admin"}
            /> */}


            {/* <Select
              options={districts.map((district) => ({
                value: district.id,
                label: district.label,
              }))}
              value={districtName ? { label: districtName } : null}
              onChange={(selectedOption) => {
                if (authData?.UserType === "Admin") {
                  if (!selectedOption) {
                    handleRefresh();
                  } else {
                    handleDistrictChange(selectedOption)
                  }
                }
              }
              }
              placeholder="Select District"
              isClearable={true}
              styles={customStyles}
              className="mt-2"
              isDisabled={authData?.UserRole === "Viewer"}
            />

            <Select
              options={ulbs.map((ulbs) => ({
                value: ulbs.id,
                label: ulbs.lable,
              }))}
              value={ulbName ? { label: ulbName } : null}
              onChange={(selectedOption) => {
                if (authData?.UserType === "Admin") {
                  handleUlbChange(selectedOption)
                }
              }
              }
              placeholder="Select Ulbs"
              isClearable={true}
              styles={customStyles}
              className="mt-2"
              isDisabled={!districtName || authData?.UserRole !== "Viewer"}
            /> */}

            
            <div className="mt-2">
              <label className="lebel-card-text">Select layer</label>
              <Select
                options={layers.map((layers) => ({
                  id: layers.id,
                  label: layers.name,
                }))}
                value={selectedLayer ? { label: selectedLayer } : null}
                onChange={(selectedOption) =>
                  handleLayerChange(selectedOption)
                }
                placeholder="Select layer"
                isClearable={true}
                styles={customStyles}
                isDisabled={!ulbName}
              // className="mt-2"
              />
            </div>

            <div className="mt-2">
              <label className="lebel-card-text">Select Field</label>
              <Select
                options={fields
                  ?.filter(field => ['name', 'area'].includes(field))
                  .map(field => ({ value: field, label: field }))} // Ensure proper format
                value={selectedField ? { label: selectedField } : null}
                onChange={(selectedOption) => handleFieldChange(selectedOption)}
                placeholder="Select Field"
                isClearable={true}
                styles={customStyles}
                isDisabled={!selectedLayer}
              // className="mt-2"
              />
            </div>
            <div className="mt-2">
              <label className="lebel-card-text">Select Field Value</label>
              <Select
                options={fieldValues.map((layers) => ({
                  label: layers
                }))}
                value={selectedFieldValue ? { label: selectedFieldValue } : null}
                onChange={(selectedOption) =>
                  handleFieldValueChange(selectedOption)
                }
                placeholder="Select Field Value"
                isClearable={true}
                isDisabled={!selectedField}
                styles={customStyles}
              // className="mt-2"
              />
            </div>
            <div className="mt-2">
              <label className='lebel-card-text mt-2 mb-2'>Buffer Distance</label>
              <input
                id="buffer-distance"
                type="number"
                min="0"
                step="any"
                value={bufferDistance}
                onChange={(e) => setBufferDistance(e.target.value)}
                placeholder="Enter buffer distance"
                className="form-control buffer-form-control"
                disabled={!selectedFieldValue}
                style={{
                  backgroundColor: isTheme === 'light' ? '#F5F5F5' : '#002864',
                  color: isTheme === 'light' ? '#000000' : 'white',
                }}
              />
            </div>
            <div className="mt-2">
              <label className="lebel-card-text">Select Unit</label>
              <Select
                options={['Meters', 'kilometers', 'miles'].map((values) => ({
                  label: values
                }))}
                onChange={(selectedOption) =>
                  handleUniteValueChange(selectedOption)
                }
                value={bufferUnit ? { label: bufferUnit } : null}
                placeholder="Select Unit"
                isClearable={true}
                styles={customStyles}
                // className="mt-2"
                isDisabled={!bufferDistance}
              />
            </div>
            <div className="mt-2">
              <label className="lebel-card-text">Spatial Relation</label>
              <Select
                options={['Intersects', 'Completely inside'].map((values) => ({
                  label: values
                }))}
                value={selectedSpatialRelationship ? { label: selectedSpatialRelationship } : null}
                onChange={(selectedOption) =>
                  handleSpatislRelation(selectedOption)
                }
                placeholder="Spatial Relation"
                isClearable={true}
                styles={customStyles}
                // className="mt-2"
                isDisabled={!bufferUnit}
              />
            </div>

            <div className='buffer-btndiv'>
              <button
                className="btn-refresh"
                onClick={handleRefresh}
                style={{ marginTop: "10px" }}
              >

                {isTheme === 'light' ?
                  <img src="img/refreshlight.svg" alt="refresh" width="20px" height="20px" />
                  :
                  <img src="img/refresh.svg" alt="refresh" />
                }  Refresh
              </button>
              <button
                className={!bufferDistance || !bufferUnit || !selectedDistrict ? "btn-comman btn-runtax comman-text" : "btn-adddestination"}
                onClick={handleBufferButtonClick}

                style={{ marginTop: "10px", background: "linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)", color: isTheme === 'light' ? "white " : "black" }}

                disabled={!bufferDistance || !bufferUnit || !selectedDistrict}
              >
                Create Buffer
              </button>
            </div>
          </>
          : ''
      }
    </div>
  )
}

export default BufferTool;



